import { BETA_FEATURE_COPY } from "../../pages/settings/beta/betaFeatures.copy";
import type {
  AdminBetaFeatureRow,
  AllowedBetaFeaturesResponse,
  BetaAllowListSettingResponse,
  BetaFeatureDefinition,
  MemberBetaFeatureRow,
} from "./betaFeatures.types";

const onlyStrings = (value: unknown): string[] =>
  Array.isArray(value) ? value.filter((item): item is string => typeof item === "string") : [];

export const toAllowedKeys = (response: AllowedBetaFeaturesResponse | null | undefined): string[] =>
  onlyStrings(response?.allowed);

export const toAllowListKeys = (response: BetaAllowListSettingResponse | null | undefined): string[] =>
  onlyStrings(response?.value);

const copyFor = (key: string) =>
  BETA_FEATURE_COPY[key] ?? { label: key, description: "" };

/** Registry features the organization allows, with the member's own on/off. */
export const toMemberRows = (
  registry: readonly BetaFeatureDefinition[],
  allowed: readonly string[],
  isEnabled: (flag: string) => boolean,
): MemberBetaFeatureRow[] =>
  registry
    .filter((feature) => allowed.includes(feature.key))
    .map((feature) => ({
      key: feature.key,
      ...copyFor(feature.key),
      enabled: isEnabled(feature.flag),
    }));

/** Every registry feature, flagged by whether the organization allows it. */
export const toAdminRows = (
  registry: readonly BetaFeatureDefinition[],
  allowed: readonly string[],
): AdminBetaFeatureRow[] =>
  registry.map((feature) => ({
    key: feature.key,
    ...copyFor(feature.key),
    allowed: allowed.includes(feature.key),
  }));

/**
 * The whole array to write after one switch. Keys the registry does not know (set elsewhere)
 * stay as they are; the result has no duplicates.
 */
export const nextAllowList = (current: readonly string[], key: string, on: boolean): string[] => {
  const rest = current.filter((item) => item !== key);
  return on ? [...rest, key] : rest;
};
